import { createContext } from 'react';

export const AccountActionsPlacementContext = createContext<'header' | 'navigation'>('header');
